/** @format */

import { Component, Input, OnInit } from '@angular/core';
import { selectBundleShipToMeButtonText } from '@pdp/data-access/state';
import {
	FulfillmentButtonInterface,
	selectShipMode,
	selectShipToMeButtonText
} from '@pdp/add-to-cart/data-access';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectHomrScheduleContent } from '@state/data-access';
import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeZipCodeButtonComponent } from '../../../change-zip-code-button/change-zip-code-button.component';
import { CommonTimerModule } from '@shared/components';

@Component({
	selector: 'pdp-feature-ship-to-me-subtext',
	templateUrl: './ship-to-me-subtext.component.html',
	styleUrl: './ship-to-me-subtext.component.scss',
	imports: [NgClass, ChangeZipCodeButtonComponent, CommonTimerModule, AsyncPipe]
})
export class ShipToMeSubtextComponent implements OnInit {
	@Input() isBundle = false;

	shipMode$ = this.store.select(selectShipMode);

	shipToMeButtonText$: Observable<FulfillmentButtonInterface>;

	GTGTHomrScheduleContent$ = this.store.select(selectHomrScheduleContent);

	timerRunning = true;

	constructor(private store: Store) {}

	ngOnInit(): void {
		this.shipToMeButtonText$ = this.getShipToMeButtonTextSelector();
	}

	getShipToMeButtonTextSelector(): Observable<FulfillmentButtonInterface> {
		return this.isBundle
			? this.store.select(selectBundleShipToMeButtonText)
			: this.store.select(selectShipToMeButtonText);
	}
}
